export default __webpack_public_path__ + "static/media/BingoCard.e147ee8a.svg";